// `sage preset` installed this file automatically.
// Running `sage preset` again could result in automatic deletion of this file.
// Because of this, we do not recommend editing this file.
import 'what-input'

import 'foundation-sites/js/entries/plugins/foundation.reveal'
import 'foundation-sites/js/entries/plugins/foundation.util.mediaQuery'
import 'foundation-sites/js/entries/plugins/foundation.offcanvas'

jQuery(document).ready($ => ($(document).foundation()));



// WEBPACK FOOTER //
// ./scripts/autoload/_foundation.js